import React, { useState } from 'react';
import {
    readAdminForegroundOrderNotificationsEnabled,
    writeAdminForegroundOrderNotificationsEnabled,
} from "../../../../config/adminOrderNotificationsPref";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    Box,
    Stack,
    DialogTitle,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import axios from 'axios';
import {useTranslation} from "react-i18next";
import {defaultVariables} from "../../../../config";
import {loadSetting} from "../../../../config/Security";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../components/elements/LoadingButton";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import SubTitle from "../../../components/elements/SubTitle";
import RayaField from "../../../components/elements/fields/RayaField";
import {currencySymbol} from "../../../../config/values";
import NumberField from "../../../components/elements/fields/NumberField";
import Title from "../../../components/elements/Title";

const APP_VERSION_PROFILES = [
    { key: 'user', titleKey: 'appVersionProfileUser', suffix: '' },
    { key: 'supplier', titleKey: 'appVersionProfileSupplier', suffix: '_supplier' },
    { key: 'transport', titleKey: 'appVersionProfileTransport', suffix: '_transport' },
];

const versionFieldName = (base, suffix) => (suffix ? `${base}${suffix}` : base);


const SiteSettings = ({ setting, user }) => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [fields, setFields] = useState({
        app_name: setting.app_name,
        short_bio: setting.short_bio || '',
        shop_initial_rate: setting.shop_initial_rate || '',
        product_initial_rate: setting.product_initial_rate || '',
        footer_text: setting.footer_text || '',
        instagram_url: setting.instagram_url || '',
        facebook_url: setting.facebook_url || '',
        x_url: setting.x_url || '',
        linkedin_url: setting.linkedin_url || '',
        whatsapp_url: setting.whatsapp_url || '',
        telegram_url: setting.telegram_url || '',
        main_phone: setting.main_phone || '',
        main_email: setting.main_email || '',
        main_address: setting.main_address || '',
        restaurants_transfer_price: setting.restaurants_transfer_price || '',
        restaurants_commission: setting.restaurants_commission || '',
        restaurants_transfer_time: setting.restaurants_transfer_time || '',
        markets_transfer_price: setting.markets_transfer_price || '',
        markets_commission: setting.markets_commission || '',
        markets_radius: setting.markets_radius || '',
        markets_transfer_time: setting.markets_transfer_time || '',
        restaurants_radius: setting.restaurants_radius || '',
        android_url: setting.android_url || '',
        current_version_android: setting.current_version_android || '',
        ls_version_android: setting.ls_version_android || '',
        ios_url: setting.ios_url || '',
        current_version_ios: setting.current_version_ios || '',
        ls_version_ios: setting.ls_version_ios || '',
        android_url_supplier: setting.android_url_supplier || '',
        current_version_android_supplier: setting.current_version_android_supplier || '',
        ls_version_android_supplier: setting.ls_version_android_supplier || '',
        ios_url_supplier: setting.ios_url_supplier || '',
        current_version_ios_supplier: setting.current_version_ios_supplier || '',
        ls_version_ios_supplier: setting.ls_version_ios_supplier || '',
        android_url_transport: setting.android_url_transport || '',
        current_version_android_transport: setting.current_version_android_transport || '',
        ls_version_android_transport: setting.ls_version_android_transport || '',
        ios_url_transport: setting.ios_url_transport || '',
        current_version_ios_transport: setting.current_version_ios_transport || '',
        ls_version_ios_transport: setting.ls_version_ios_transport || '',
        footer_menu_1_link: setting.footer_menu_1_link || '',
        footer_menu_1_text: setting.footer_menu_1_text || '',
        footer_menu_2_link: setting.footer_menu_2_link || '',
        footer_menu_2_text: setting.footer_menu_2_text || '',
        footer_menu_3_link: setting.footer_menu_3_link || '',
        footer_menu_3_text: setting.footer_menu_3_text || '',
        footer_menu_4_link: setting.footer_menu_4_link || '',
        footer_menu_4_text: setting.footer_menu_4_text || '',
        courier_radius: setting.courier_radius || '',
        courier_time: setting.courier_time || '',
        courier_punishment: setting.courier_punishment || '',
        live_location_update: setting.live_location_update || '',
        orders_pending_time: setting.orders_pending_time || '',
        order_finishing_tolerance: setting.order_finishing_tolerance || '',
        restaurants_courier_rate: setting.restaurants_courier_rate || '',
        markets_courier_rate: setting.markets_courier_rate || '',
        donors_table: setting.donors_table || '',
        restaurants_nt_commission: setting.restaurants_nt_commission || '',
        markets_nt_commission: setting.markets_nt_commission || '',
        restaurants_nt_transfer_price: setting.restaurants_nt_transfer_price || '',
        markets_nt_transfer_price: setting.markets_nt_transfer_price || '',
    });

    const [paymentFields, setPaymentFields] = useState({
        restaurants_payment_gateway: setting.restaurants_payment_gateway || 'param',
        markets_payment_gateway: setting.markets_payment_gateway || 'param',
        wallet_deposit_payment_gateway: setting.wallet_deposit_payment_gateway || 'param',
    });
    const [paymentSaveLoading, setPaymentSaveLoading] = useState(false);
    const [paymentConfirmOpen, setPaymentConfirmOpen] = useState(false);

    const [submitLoading, setSubmitLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [adminForegroundOrderNotifs, setAdminForegroundOrderNotifs] = useState(
        () => readAdminForegroundOrderNotificationsEnabled(),
    );

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };

    const handleValidation = () => {
        const newErrors = {};
        let formIsValid = true;

        if (!fields.app_name) {
            formIsValid = false;
            newErrors.app_name = t('emptyField');
        }


        setErrors(newErrors);

        return formIsValid;
    };

    const handleRequest = async () => {
        const data = new FormData();
        Object.keys(fields).forEach((key) => {
            data.append(key, fields[key]);
        });

        try {
            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };

            await axios.post(`${defaultVariables.url}/setting/save`, data, config);
            await loadSetting();
        } catch (error) {
            console.error(error.response);
        } finally {
            setSubmitLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        if (handleValidation()) {
            handleRequest();
        } else {
            setSubmitLoading(false);
        }
    };

    const handleInputChange = (fieldName, value) => {
        setFields((prevFields) => ({
            ...prevFields,
            [fieldName]: value,
        }));
    };

    const gatewayLabel = (code) =>
        code === 'iyzipay' ? t('paymentGatewayIyzipay') : t('paymentGatewayParam');

    const gatewayHighlightSx = { fontWeight: 700, color: 'error.main' };

    const PaymentConfirmGateway = ({ code }) => (
        <Box component="span" sx={gatewayHighlightSx}>
            {gatewayLabel(code)}
        </Box>
    );

    const savePaymentMethods = async () => {
        setPaymentSaveLoading(true);
        const data = new FormData();
        Object.keys(paymentFields).forEach((key) => {
            data.append(key, paymentFields[key]);
        });
        try {
            const loginToken = localStorage.getItem('ACT');
            await axios.post(`${defaultVariables.url}/setting/save`, data, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            });
            await loadSetting();
            enqueueSnackbar(t('paymentMethodsSaved'), { variant: 'success' });
            setPaymentConfirmOpen(false);
        } catch (error) {
            console.error(error.response);
            enqueueSnackbar(t('paymentMethodsSaveFailed'), { variant: 'error' });
        } finally {
            setPaymentSaveLoading(false);
        }
    };

    return (
        <Grid container spacing={2} className="manage-holder">
            <Grid item size={12} style={{marginTop:10}}>
                <Title color="text" align="left" className="panel-title" >
                    {t('defaultSettings')}
                </Title>
            </Grid>
            {user?.role?.name === 'admin' && (
                <>
                    <Grid item size={12}>
                        <SubTitle>{t('notificationSettings')}</SubTitle>
                    </Grid>
                    <Grid item size={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={adminForegroundOrderNotifs}
                                    onChange={(e) => {
                                        const next = e.target.checked;
                                        setAdminForegroundOrderNotifs(next);
                                        writeAdminForegroundOrderNotificationsEnabled(next);
                                    }}
                                />
                            }
                            label={
                                <Typography variant="body2">
                                    {t('adminForegroundOrderNotifications')}
                                </Typography>
                            }
                        />
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ pl: 4, mt: -0.5 }}>
                            {t('adminForegroundOrderNotificationsHelp')}
                        </Typography>
                    </Grid>
                    <Grid item size={12}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => navigate('/panel/manage/setting/notification-manager')}
                        >
                            {t('notificationManagerTitle')}
                        </Button>
                    </Grid>
                </>
            )}
            {user?.role?.name === 'admin' && (
                <>
                    <Grid item size={12}>
                        <SubTitle>{t('paymentMethodsSettings')}</SubTitle>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="restaurants-payment-gateway-label">
                                {t('paymentMethodsRestaurants')}
                            </InputLabel>
                            <Select
                                labelId="restaurants-payment-gateway-label"
                                label={t('paymentMethodsRestaurants')}
                                value={paymentFields.restaurants_payment_gateway}
                                onChange={(e) =>
                                    setPaymentFields((p) => ({
                                        ...p,
                                        restaurants_payment_gateway: e.target.value,
                                    }))
                                }
                            >
                                <MenuItem value="param">{t('paymentGatewayParam')}</MenuItem>
                                <MenuItem value="iyzipay">{t('paymentGatewayIyzipay')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="markets-payment-gateway-label">
                                {t('paymentMethodsMarkets')}
                            </InputLabel>
                            <Select
                                labelId="markets-payment-gateway-label"
                                label={t('paymentMethodsMarkets')}
                                value={paymentFields.markets_payment_gateway}
                                onChange={(e) =>
                                    setPaymentFields((p) => ({
                                        ...p,
                                        markets_payment_gateway: e.target.value,
                                    }))
                                }
                            >
                                <MenuItem value="param">{t('paymentGatewayParam')}</MenuItem>
                                <MenuItem value="iyzipay">{t('paymentGatewayIyzipay')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="wallet-deposit-payment-gateway-label">
                                {t('paymentMethodsWalletDeposit')}
                            </InputLabel>
                            <Select
                                labelId="wallet-deposit-payment-gateway-label"
                                label={t('paymentMethodsWalletDeposit')}
                                value={paymentFields.wallet_deposit_payment_gateway}
                                onChange={(e) =>
                                    setPaymentFields((p) => ({
                                        ...p,
                                        wallet_deposit_payment_gateway: e.target.value,
                                    }))
                                }
                            >
                                <MenuItem value="param">{t('paymentGatewayParam')}</MenuItem>
                                <MenuItem value="iyzipay">{t('paymentGatewayIyzipay')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item size={12}>
                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            startIcon={<SaveRoundedIcon />}
                            loading={paymentSaveLoading}
                            onClick={() => setPaymentConfirmOpen(true)}
                        >
                            {t('paymentMethodsSaveChanges')}
                        </LoadingButton>
                    </Grid>
                    <Dialog
                        open={paymentConfirmOpen}
                        onClose={() => !paymentSaveLoading && setPaymentConfirmOpen(false)}
                    >
                        <DialogTitle>{t('paymentMethodsConfirmTitle')}</DialogTitle>
                        <DialogContent>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                {t('paymentMethodsConfirmIntro')}
                            </Typography>
                            <Stack component="ul" spacing={1.5} sx={{ m: 0, pl: 2.5 }}>
                                <Typography component="li" variant="body1">
                                    <strong>{t('paymentMethodsConfirmRestaurants')}:</strong>{' '}
                                    <PaymentConfirmGateway code={paymentFields.restaurants_payment_gateway} />
                                </Typography>
                                <Typography component="li" variant="body1">
                                    <strong>{t('paymentMethodsConfirmMarkets')}:</strong>{' '}
                                    <PaymentConfirmGateway code={paymentFields.markets_payment_gateway} />
                                </Typography>
                                <Typography component="li" variant="body1">
                                    <strong>{t('paymentMethodsConfirmWallet')}:</strong>{' '}
                                    <PaymentConfirmGateway code={paymentFields.wallet_deposit_payment_gateway} />
                                </Typography>
                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setPaymentConfirmOpen(false)}
                                disabled={paymentSaveLoading}
                            >
                                {t('cancelTooltip')}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={savePaymentMethods}
                                disabled={paymentSaveLoading}
                            >
                                {t('paymentMethodsSaveChanges')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            )}
            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.app_name}
                    fullWidth

                    label={t('app_name')}
                    name="app_name"
                    onChange={handleChange}
                    error={!!errors.app_name}
                    helperText={errors.app_name}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('shop_initial_rate')}
                    variant="outlined"
                    value={fields.shop_initial_rate}
                    endAdornment={"/5"}
                    decimals={0}
                    min={0}
                    max={5}
                    onChange={(res) => handleInputChange('shop_initial_rate', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('product_initial_rate')}
                    variant="outlined"
                    value={fields.product_initial_rate}
                    endAdornment={"/5"}
                    decimals={0}
                    min={0}
                    max={5}
                    onChange={(res) => handleInputChange('product_initial_rate', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('order_finishing_tolerance')}
                    variant="outlined"
                    value={fields.order_finishing_tolerance}
                    endAdornment={t('hours')}
                    placeholer={t('order_finishing_tolerance_desc')}
                    min={0}
                    onChange={(res) => handleInputChange('order_finishing_tolerance', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('orders_pending_time')}
                    variant="outlined"
                    value={fields.orders_pending_time}
                    endAdornment={t("hours")}
                    min={0}
                    onChange={(res) => handleInputChange('orders_pending_time', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('donors_table')}
                    variant="outlined"
                    value={fields.donors_table}
                    min={0}
                    onChange={(res) => handleInputChange('donors_table', res)}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    value={fields.short_bio}
                    fullWidth
                    multiline
                    rows="4"
                    label={t('short_bio')}
                    name="short_bio"
                    onChange={handleChange}
                    error={!!errors.short_bio}
                    helperText={errors.short_bio}
                />
            </Grid>
            <Grid item size={12} style={{marginTop:10}}>
                <Title color="text" align="left" className="panel-title" >
                    {t('contactSettings')}
                </Title>
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.main_phone}
                    fullWidth
                    
                    label={t('websitePhone')}
                    name="main_phone"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.main_email}
                    fullWidth
                    
                    label={t('websiteEmail')}
                    name="main_email"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.main_address}
                    fullWidth
                    
                    label={t('websiteAddress')}
                    name="main_address"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.instagram_url}
                    fullWidth
                    
                    label="Instagram URL"
                    name="instagram_url"
                    onChange={handleChange}
                />
            </Grid>

            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.facebook_url}
                    fullWidth
                    
                    label="Facebook URL"
                    name="facebook_url"
                    onChange={handleChange}
                />
            </Grid>

            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.x_url}
                    fullWidth
                    
                    label="X (Twitter) URL"
                    name="x_url"
                    onChange={handleChange}
                />
            </Grid>

            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.linkedin_url}
                    fullWidth
                    
                    label="Linkedin URL"
                    name="linkedin_url"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    variant="outlined"
                    value={fields.whatsapp_url}
                    fullWidth
                    
                    label="Whatsapp URL"
                    name="whatsapp_url"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={12}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_text}
                    fullWidth
                    label={t('footerText')}
                    name="footer_text"
                    multiline
                    rows="4"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={12} style={{marginTop:10}}>
                <Title color="text" align="left" className="panel-title" >
                    {t('restaurantsSettings')}
                </Title>
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('restaurantsTransferPrice')}
                    variant="outlined"
                    value={fields.restaurants_transfer_price}
                    endAdornment={currencySymbol}
                    decimals={2}
                    min={0}
                    onChange={(res) => handleInputChange('restaurants_transfer_price', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('restaurantsNTTransferPrice')}
                    variant="outlined"
                    value={fields.restaurants_nt_transfer_price}
                    endAdornment={currencySymbol}
                    decimals={2}
                    min={0}
                    onChange={(res) => handleInputChange('restaurants_nt_transfer_price', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    fullWidth
                    label={t('restaurantsTransferTime')}
                    variant="outlined"
                    value={fields.restaurants_transfer_time}
                    onChange={handleChange}
                    name="restaurants_transfer_time"
                    select
                >
                    <MenuItem value={10}>10 {t("minutes")}</MenuItem>
                    <MenuItem value={15}>15 {t("minutes")}</MenuItem>
                    <MenuItem value={20}>20 {t("minutes")}</MenuItem>
                    <MenuItem value={25}>25 {t("minutes")}</MenuItem>
                    <MenuItem value={30}>30 {t("minutes")}</MenuItem>
                </RayaField>
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('restaurantsCommission')}
                    variant="outlined"
                    value={fields.restaurants_commission}
                    endAdornment={"%"}
                    min={0}
                    max={100}
                    onChange={(res) => handleInputChange('restaurants_commission', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('restaurantsNTCommission')}
                    variant="outlined"
                    value={fields.restaurants_nt_commission}
                    endAdornment={"%"}
                    min={0}
                    max={100}
                    onChange={(res) => handleInputChange('restaurants_nt_commission', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('restaurantsRadius')}
                    variant="outlined"
                    value={fields.restaurants_radius}
                    min={0}
                    endAdornment={"km"}
                    onChange={(res) => handleInputChange('restaurants_radius', res)}
                />
            </Grid>
            <Grid item size={12} style={{marginTop:10}}>
                <Title color="text" align="left" className="panel-title" >
                    {t('marketsSettings')}
                </Title>
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('marketsTransferPrice')}
                    variant="outlined"
                    value={fields.markets_transfer_price}
                    endAdornment={currencySymbol}
                    decimals={2}
                    min={0}
                    onChange={(res) => handleInputChange('markets_transfer_price', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('marketsNTTransferPrice')}
                    variant="outlined"
                    value={fields.markets_nt_transfer_price}
                    endAdornment={currencySymbol}
                    decimals={2}
                    min={0}
                    onChange={(res) => handleInputChange('markets_nt_transfer_price', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <RayaField
                    fullWidth
                    label={t('marketsTransferTime')}
                    variant="outlined"
                    value={fields.markets_transfer_time}
                    onChange={handleChange}
                    name="markets_transfer_time"
                    select
                >
                    <MenuItem value={10}>10 {t("minutes")}</MenuItem>
                    <MenuItem value={15}>15 {t("minutes")}</MenuItem>
                    <MenuItem value={20}>20 {t("minutes")}</MenuItem>
                    <MenuItem value={25}>25 {t("minutes")}</MenuItem>
                    <MenuItem value={30}>30 {t("minutes")}</MenuItem>
                </RayaField>
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('marketsCommission')}
                    variant="outlined"
                    value={fields.markets_commission}
                    endAdornment={"%"}
                    min={0}
                    max={100}
                    onChange={(res) => handleInputChange('markets_commission', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('marketsNTCommission')}
                    variant="outlined"
                    value={fields.markets_nt_commission}
                    endAdornment={"%"}
                    min={0}
                    max={100}
                    onChange={(res) => handleInputChange('markets_nt_commission', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('marketsRadius')}
                    variant="outlined"
                    value={fields.markets_radius}
                    endAdornment={"km"}
                    min={0}
                    onChange={(res) => handleInputChange('markets_radius', res)}
                />
            </Grid>
            <Grid item size={12} style={{marginTop:10}}>
                <Title color="text" align="left" className="panel-title" >
                    {t('couriersSettings')}
                </Title>
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('courier_radius')}
                    variant="outlined"
                    value={fields.courier_radius}
                    endAdornment={"km"}
                    min={0}
                    onChange={(res) => handleInputChange('courier_radius', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('courier_time')}
                    variant="outlined"
                    value={fields.courier_time}
                    placeholder={t('courier_time_desc')}
                    endAdornment={t('minutes')}
                    min={0}
                    onChange={(res) => handleInputChange('courier_time', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('courier_punishment')}
                    variant="outlined"
                    value={fields.courier_punishment}
                    placeholder={t('courier_punishment_desc')}
                    endAdornment={t("hours")}
                    min={0}
                    onChange={(res) => handleInputChange('courier_punishment', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('live_location_update')}
                    variant="outlined"
                    value={fields.live_location_update}
                    endAdornment={t('minutes')}
                    min={0}
                    onChange={(res) => handleInputChange('live_location_update', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('restaurants_courier_rate')}
                    variant="outlined"
                    value={fields.restaurants_courier_rate}
                    endAdornment={"%"}
                    min={0}
                    onChange={(res) => handleInputChange('restaurants_courier_rate', res)}
                />
            </Grid>
            <Grid item size={{xs:12,md:6,lg:4}}>
                <NumberField
                    fullWidth
                    label={t('markets_courier_rate')}
                    variant="outlined"
                    value={fields.markets_courier_rate}
                    endAdornment={"%"}
                    min={0}
                    onChange={(res) => handleInputChange('markets_courier_rate', res)}
                />
            </Grid>
            <Grid item size={12}>
                <Title color="text" align="left" className="panel-title" >
                    {t('appSettings')}
                </Title>
            </Grid>
            {APP_VERSION_PROFILES.map((profile) => (
                <React.Fragment key={profile.key}>
                    <Grid item size={12}>
                        <SubTitle align="left">{t(profile.titleKey)}</SubTitle>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <RayaField
                            variant="outlined"
                            value={fields[versionFieldName('android_url', profile.suffix)]}
                            fullWidth
                            label={t('androidUrl')}
                            name={versionFieldName('android_url', profile.suffix)}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <RayaField
                            variant="outlined"
                            value={fields[versionFieldName('current_version_android', profile.suffix)]}
                            fullWidth
                            label={t('currentVersionAndroid')}
                            name={versionFieldName('current_version_android', profile.suffix)}
                            placeholder="1.1.0"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <RayaField
                            variant="outlined"
                            value={fields[versionFieldName('ls_version_android', profile.suffix)]}
                            fullWidth
                            label={t('lsVersionAndroid')}
                            name={versionFieldName('ls_version_android', profile.suffix)}
                            placeholder="1.0.0"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <RayaField
                            variant="outlined"
                            value={fields[versionFieldName('ios_url', profile.suffix)]}
                            fullWidth
                            label={t('iosUrl')}
                            name={versionFieldName('ios_url', profile.suffix)}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <RayaField
                            variant="outlined"
                            value={fields[versionFieldName('current_version_ios', profile.suffix)]}
                            fullWidth
                            label={t('currentVersionIos')}
                            name={versionFieldName('current_version_ios', profile.suffix)}
                            placeholder="1.1.0"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <RayaField
                            variant="outlined"
                            value={fields[versionFieldName('ls_version_ios', profile.suffix)]}
                            fullWidth
                            label={t('lsVersionIos')}
                            name={versionFieldName('ls_version_ios', profile.suffix)}
                            placeholder="1.0.0"
                            onChange={handleChange}
                        />
                    </Grid>
                </React.Fragment>
            ))}
            <Grid item size={12}>
                <Typography variant="caption" color="text.secondary">
                    {t('appVersionSettingsHint')}
                </Typography>
            </Grid>
            <Grid item size={12} style={{marginTop:10}}>
                <Title color="text" align="left" className="panel-title" >
                    {t('menuSettings')}
                </Title>
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_menu_1_link}
                    fullWidth
                    
                    label={t('footer_menu_1_link')}
                    name="footer_menu_1_link"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_menu_1_text}
                    fullWidth
                    
                    label={t('footer_menu_1_text')}
                    name="footer_menu_1_text"
                    onChange={handleChange}
                />
            </Grid>

            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_menu_2_link}
                    fullWidth
                    
                    label={t('footer_menu_2_link')}
                    name="footer_menu_2_link"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_menu_2_text}
                    fullWidth
                    
                    label={t('footer_menu_2_text')}
                    name="footer_menu_2_text"
                    onChange={handleChange}
                />
            </Grid>

            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_menu_3_link}
                    fullWidth
                    
                    label={t('footer_menu_3_link')}
                    name="footer_menu_3_link"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_menu_3_text}
                    fullWidth
                    
                    label={t('footer_menu_3_text')}
                    name="footer_menu_3_text"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_menu_4_link}
                    fullWidth
                    
                    label={t('footer_menu_4_link')}
                    name="footer_menu_4_link"
                    onChange={handleChange}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    value={fields.footer_menu_4_text}
                    fullWidth
                    
                    label={t('footer_menu_4_text')}
                    name="footer_menu_4_text"
                    onChange={handleChange}
                />
            </Grid>

            <Grid item size={12}>
                <LoadingButton
                    variant="contained"
                    color="primary"
                    startIcon={<SaveRoundedIcon />}
                    onClick={handleSubmit}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>
        </Grid>

    );
};
const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    setting: state.setting
});

export default withStyles(Styles)(connect(mstp)(SiteSettings));
